import React from 'react';
import Header from './Header';
import { Container } from './styled';

const Main = ({ text, isDone, items, background, children }: { background: string, text: string, isDone: boolean, items: boolean[], children: React.ReactNode }) => {
  return (
    <Container color={background}>
      <Header text={text} />
      {children}
    </Container>
  );
};
export default Main;
